module.exports = "pegasus/assets/tech/webinar/100.png";